export default "__VITE_ASSET__6ewH5Hci__"